import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useUserRoleSelectContext } from './UserRoleSelectContext'

/**
 * a complex {@link CIMSSelect} for users and roles
 */
const UserRoleSelect: React.FC<CommonSelect<'virtual'>> = (props) => {
  const { loading, options } = useUserRoleSelectContext()
  return <CIMSSelect loading={loading} options={options} {...props} />
}

export default UserRoleSelect
